<div class="table-container-scroll mat-elevation-z2">
  <section class="example-container table-scroll-region" tabindex="0">
    <mat-table
      [dataSource]="transactions"
      matSort
      (matSortChange)="sortData($event)"
      class="custom-column-divider modern-table"
    >
      @for (col of columns; track col.key) {
        <ng-container [matColumnDef]="col.key">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="table-header-cell"
          >
            {{ col.label }}
          </th>

          <td mat-cell *matCellDef="let row" class="table-data-cell">
            @if (col.key === "logs") {
              <ng-container>
                <div class="actions-col">
                  <button mat-menu-item (click)="openLogDetails(row)">
                    <img
                      src="../../../../assets/icons/logs.png"
                      width="20px"
                      alt="View details"
                      class="src"
                    />
                  </button>
                </div>
              </ng-container>
            }

            @if (col.key !== "select" && col.key !== "actions") {
              <span>
                @switch (col.key) {
                  @case ("serviceProvider") {
                    <span>
                      {{
                        row[col.key] === null
                          ? "No Service Provider"
                          : row[col.key]
                      }}
                    </span>
                  }
                  @case ("status") {
                    <span
                      class="table-data-text"
                      [ngClass]="{
                        'imported-status': row[col.key] === 'Imported',
                        'error-status':
                          row[col.key] === 'Error' || row[col.key] === 'Failed',
                        'default-status':
                          row[col.key] !== 'Imported' &&
                          row[col.key] !== 'Error' &&
                          row[col.key] !== 'Open' &&
                          row[col.key] !== 'Failed',
                      }"
                    >
                      @if (row[col.key] === "Imported") {
                        <img
                          src="../../../../../assets/icons/Imported.png"
                          alt=""
                        />
                      } @else if (row[col.key] === "Error") {
                        <img
                          src="../../../../../assets/icons/Failed.png"
                          alt=""
                        />
                      } @else if (row[col.key] === "Open") {
                        <img
                          width="60"
                          src="../../../../../assets/icons/Open.png"
                          alt=""
                        />
                      } @else if (
                        row[col.key] !== "Imported" &&
                        row[col.key] !== "Error" &&
                        row[col.key] !== "Open" &&
                        row[col.key] !== "Failed"
                      ) {
                        {{ row[col.key] }}
                      }
                    </span>
                  }
                  @case ("importDate") {
                    <span>
                      {{ row[col.key] === "" ? "No Date" : row[col.key] }}
                    </span>
                  }
                  @case ("client") {
                    <span>
                      {{ row[col.key] === null ? "No Client" : row[col.key] }}
                    </span>
                  }
                  @default {
                    {{ row[col.key] }}
                  }
                }
              </span>
            }
          </td>
        </ng-container>
      }

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="modern-table-header-row"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="modern-table-data-row"
      ></tr>

      <tr class="mat-row no-data-row" *matNoDataRowDef>
        <td class="mat-cell" [attr.colspan]="transactions.length">
          No data matching the filter.
        </td>
      </tr>
    </mat-table>
  </section>
</div>
